export default __webpack_public_path__ + "29b6ff8.png";